import {Component, Inject, OnInit, Optional, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UploadFileExpedienteService} from './upload-file-expediente.service';
import {MessageCrudService} from '@evomatik/evk-common';

@Component({
    selector: 'lib-uploap-file-expediente',
    templateUrl: './upload-file-expediente.component.html',
    styleUrls: ['./upload-file-expediente.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UploapFileExpedienteComponent implements OnInit {

    fileToUpload: File | null = null;
    errors: any;
    withError: any;
    withErrorGeneral: any = false;
    loading: any = false;
    constructor(
        private uploadFileExpediente: UploadFileExpedienteService,
        private messagesCrudService: MessageCrudService,
        private message: MessageCrudService,
        public dialogRef: MatDialogRef<UploapFileExpedienteComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
    }

    handleFileInput(files: FileList) {
        if (files.length && files.length > 0) {
            const fileSize: number = files.item(0).size;
            const siezekiloByte: any = parseInt(`${fileSize / 1024}`);
            if (siezekiloByte > 5000) {
                this.message.snackbarMessage('El tamaño máximo del archivo deben ser 5MB');
                return;
            }

            if (["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"].indexOf(files.item(0).type) !== -1) {
                this.fileToUpload = files.item(0);
            } else {
                this.message.snackbarMessage('Adjunte un archivo válido.');
            }
        } else {
            this.fileToUpload = null;
        }
    }

    uploadFileToActivity() {
        const confirmDialog = this.messagesCrudService.openConfirmDialog({
            warn: '¿Está seguro de cargar el archivo?',
            goonbtn: 'Aceptar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            confirmDialog.close();
            let formData = new FormData();
            formData.append('file', this.fileToUpload);
            this.loading = true;
            this.uploadFileExpediente.postFile(formData).subscribe(data => {
                console.log(data)
                console.log(data.message);
                this.loading = false;
                if(data.errors && data.errors.length){
                    this.withError = true;
                    if(data.errors[0].row_number === 0 || data.errors[0].row_number){
                        this.errors = data.errors;
                    } else {
                        this.withErrorGeneral = true;
                    }
                } else {
                    this.dialogRef.close(true);
                    this.message.snackbarMessage('Se cargó el archivo de manera correcta.');
                }
            }, error => {
                this.loading = false;
                console.log('Ocurrio un error: ', error);
                this.message.snackbarMessage('Se produjo un error al cargar el archivo. Verifique los datos de catálogo o numéricos');
                this.withError = true;
                if(error.errors){
                    this.errors = error.errors;
                }
            });
        });
    }

    closeModal(){
        this.dialogRef.close();
        this.withError = false;
    }

}
